/**
 * View modes that the ReportRegistrar can be in
 * @property {string} LIVE - In LIVE mode the AppletHost should be used for settings
 * @property {string} HTML - In HTML mode all data should be retrieved from the window, and the AppletHost should NOT be used for configuration
 */
export var ViewMode;
(function (ViewMode) {
    ViewMode["LIVE"] = "live";
    ViewMode["HTML"] = "html";
})(ViewMode || (ViewMode = {}));
/**
 *
 * @param {string} mode - A possible view mode string
 * @returns {boolean} - True if mode is a valid viewMode, false otherwise
 */
export function isValidViewMode(mode) {
    return Object.keys(ViewMode).some((key) => ViewMode[key] === mode);
}
